
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("jRDDZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e2e1747af6475b12$export$2e2bcd8739ae039);

var $1Ozm9 = parcelRequire("1Ozm9");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e2e1747af6475b12$export$2e2bcd8739ae039 = ()=>(0, $1Ozm9.default)('/rest/internal/2/projectpermissions');

});


//# sourceMappingURL=async-resource-project-permissions.afed7d19.js.map
